import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import Fill from './Fill';
import { selectNormalizedInterval } from '../../../selectors';

function AvailableContentBar() {
  const [start, , duration] = useSelector(selectNormalizedInterval, shallowEqual);

  const {
    isLive,
    offsetFromLive,
    currentTime,
  } = useSelector(({ playback }) => ({
    isLive: playback.isLive,
    offsetFromLive: playback.offsetFromLive,
    currentTime: playback.currentTime,
  }), shallowEqual);

  const liveS = currentTime - start + offsetFromLive;

  if (!isLive || offsetFromLive <= 0) {
    return null;
  }

  let liveAvailable = liveS / duration;
  if (liveAvailable > 1) {
    liveAvailable = 1;
  }

  return (
    <Fill
      color="availableBarFillColor"
      left="0px"
      width={`${liveAvailable * 100}%`}
    />
  );
}

export default React.memo(AvailableContentBar);
